import { SignOut, SquaresFour, UserMinus } from 'phosphor-react';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { useLocation, useNavigate } from 'react-router-dom';
import { onUserLogout } from '../../../store/user/user-slice';
import { useMemo } from 'react';

export const useAdminLayoutItems = () => {
  const appDispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const authUser = useAppSelector(state => state.user.user);

  const onLogout = () => {
    localStorage.clear();
    navigate('/');
    appDispatch(onUserLogout());
  };

  const sidebarItems = useMemo(() => {
    const baseRoutes = [
      {
        title: 'Dashboard',
        icon: <SquaresFour size={20} color={'#202A2D'} />,
        selected: !location.pathname.includes('managers'),
        onClick: () => navigate('/admin'),
      },
    ];

    if (authUser?.role === 'admin') {
      baseRoutes.push({
        title: 'Our team',
        icon: <UserMinus size={20} color={'#202A2D'} />,
        selected: !!location.pathname.includes('managers'),
        onClick: () => navigate('/admin/managers'),
      });
    }

    return baseRoutes;
  }, [location.pathname]);

  const dropdownItems = [
    {
      title: 'Logout',
      type: 'profile',
      icon: <SignOut size={20} color={'#202A2D'} />,
      path: '/',
      onClick: onLogout,
    },
  ];

  return { sidebarItems, dropdownItems };
};
